"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var icons_1 = __importDefault(require("../../../../theme/icons"));
var layout_1 = __importDefault(require("../../../../theme/layout/layout"));
require("../Style/style.sass");
var react_i18next_1 = require("react-i18next");
function Dashboard() {
    var t = (0, react_i18next_1.useTranslation)().t;
    function Button(name, icon, link) {
        return (react_1.default.createElement("a", { className: 'dashboard-link', href: link },
            react_1.default.createElement(icons_1.default, { name: icon, width: 90, height: 90 }),
            react_1.default.createElement("div", { className: 'dashboard-title' }, name)));
    }
    return (react_1.default.createElement("div", { className: 'login' },
        react_1.default.createElement("div", { className: 'left' }),
        react_1.default.createElement(layout_1.default, null,
            react_1.default.createElement("div", { className: 'logo-container' },
                react_1.default.createElement(icons_1.default, { height: 80, name: 'logo', width: 80 }),
                react_1.default.createElement(icons_1.default, { className: 'icon_black', height: 80, name: 'AcornAppIcon', width: 220 })),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", { className: 'button-container' }, Button(t('my_finance'), 'myFinance', '/agent/underConstruction'))))));
}
exports.default = Dashboard;
